// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"72":"Cart","187":"NotFound","344":"FullPizza"}[chunkId] || chunkId) + "." + {"72":"088ab141","187":"080979c7","344":"c19a5f44","787":"3d66f7fd"}[chunkId] + ".chunk.js";
};